import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Menu from '../myComponents/Menu';
import './SetupPlatformPage.css';
import Footer from '../myComponents/Footer';

const SetupAndroidPage = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const [activeTab, setActiveTab] = useState(0);

  const toggleSection = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="App">
      <div style={{ position: 'relative', zIndex: 1000 }}>
        <Menu />
      </div>
      
      <section className="platform-setup-section">
        <div className="platform-container">
          {/* Header */}
          <div className="platform-header">
            <div className="platform-breadcrumb">
              <Link to="/setup">
                ← Все инструкции
              </Link>
            </div>
            <h1 className="platform-title">Как установить VPN на Android</h1>
            <p className="platform-description">
              RED BUTTON предлагает несколько способов для подключения к VPN на Android устройствах. <br/><br/>
              Вы можете выбрать любое приложение из списка ниже, они все бесплатные и практически не отличаются друг от друга. Мы рекомендуем приложение Happ или Hiddify.
            </p>
          </div>

          {/* App Tabs */}
          <div className="app-tabs">
            <div 
              className={`tab ${activeTab === 0 ? 'active' : ''}`}
              onClick={() => setActiveTab(0)}
            >
              ⚡ Happ
            </div>
            <div 
              className={`tab ${activeTab === 1 ? 'active' : ''}`}
              onClick={() => setActiveTab(1)}
            >
              Hiddify
            </div>
          </div>

          {/* Setup Steps */}
          <div className="setup-steps">
            
            {/* V2RayNG Tab */}
            {activeTab === 0 && (
              <>
                <div className="tab-text-content">
                  <p>Для настройки RED BUTTON на устройствах Android вам потребуется приложение Happ и ключ доступа. Рекомендуем использовать именно приложение Happ.</p>
                  
                  <h1>Установка Happ</h1>
                  <p>Скачайте и установите бесплатное приложение Happ из Google Play.</p>
                  
                  <div className="section-button">
                    <a href="https://play.google.com/store/apps/details?id=com.happproxy" target="_blank" rel="noopener noreferrer">
                        <button className="download-btn">
                        Happ из Google Play
                        </button>
                    </a>
                  </div>
                  
                  <h1>Получение ключа</h1>
                  <p>После активации VPN скопируйте Subscription link, который прислал Telegram-бот.</p>
                </div>

                <div className="setup-section">
                  <button
                    className={`section-header ${activeIndex === 0 ? 'active' : ''}`}
                    onClick={() => toggleSection(0)}
                  >
                    <h3>Получение ключа в личном кабинете</h3>
                    <span className="section-icon">
                      {activeIndex === 0 ? '−' : '+'}
                    </span>
                  </button>
                  
                  <div className={`section-content ${activeIndex === 0 ? 'active' : ''}`}>
                    <div className="section-content-inner">
                      <ol className="steps-list">
                        <li>Войдите в Telegram Бот</li>
                        <li>Сразу после оплаты бот прислал вам Subscription Link</li>
                        <li>Перейдите в раздел 'Мои конфигурации'</li>
                        <li>Откройте 'Общая подписка'</li>
                        <li>Кликните один раз на ссылку, чтобы ее скопировать</li>
                        <li>Вы также можете воспользоваться QR кодом</li>
                      </ol>
                      <div className="step-screenshot">
                        <img src="/assets/get_link.jpg" alt="Скриншот: Получение ключа" />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="tab-text-content">
                  <h1>Подключение VPN</h1>
                  <p>Откройте приложени Happ. Нажмите "+" в правом верхнем углу и выберите "Импорт конфигурации из буфера обмена". Выберите сервер и нажмите на переключатель для подключения. Вы так же можете воспользоваться опцией QR кода.</p>
                  <p>Готово! Теперь вы подключены к быстрому и надежному VPN. 🚀</p>
                </div>
              </>
            )}

            {/* Hiddify Tab */}
            {activeTab === 1 && (
              <>
                <div className="tab-text-content">
                  <p>Hiddify - современное и мощное приложение с открытым исходным кодом для всех популярных протоколов VPN.</p>
                  <p>Процесс установки очень простой и интуитивно понятный</p>
                  
                  <h1>Установка Hiddify</h1>
                  <p>Скачайте и установите бесплатное приложение Hiddify из Google Play.</p>
                  
                  <div className="section-button">
                    <a href="https://play.google.com/store/apps/details?id=app.hiddify.com" target="_blank" rel="noopener noreferrer">
                        <button className="download-btn">
                        Скачать Hiddify
                        </button>
                    </a>
                  </div>
                  
                  <h1>Получение ключа</h1>
                  <p>После активации VPN скопируйте Subscription link, который прислал Telegram-бот.</p>
                </div>

                <div className="setup-section">
                  <button
                    className={`section-header ${activeIndex === 0 ? 'active' : ''}`}
                    onClick={() => toggleSection(0)}
                  >
                    <h3>Получение ключа в личном кабинете</h3>
                    <span className="section-icon">
                      {activeIndex === 0 ? '−' : '+'}
                    </span>
                  </button>
                  
                  <div className={`section-content ${activeIndex === 0 ? 'active' : ''}`}>
                    <div className="section-content-inner">
                      <ol className="steps-list">
                        <li>Войдите в Telegram Бот</li>
                        <li>Сразу после оплаты бот прислал вам Subscription Link</li>
                        <li>Перейдите в раздел 'Мои конфигурации'</li>
                        <li>Откройте 'Общая подписка'</li>
                        <li>Кликните один раз на ссылку, чтобы ее скопировать</li>
                        <li>Вы также можете воспользоваться QR кодом</li>
                      </ol>
                      <div className="step-screenshot">
                        <img src="/assets/get_link.jpg" alt="Скриншот: Получение ключа" />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="tab-text-content">
                  <h1>Настройка Hiddify</h1>
                  <p>Выберите свою страну в настройках. При выборе региона "Россия" доступ ко всем .RU и .РФ сайтам, сервисам VK и Yandex будет "напрямую" (без VPN). Поэтому для проверки локации не используйте 2ip.ru, а используйте whoer.net.</p>
                  <p>Если вы хотите, чтобы подключение до всех адресов шло через VPN — выберите в качестве страны "Другой"</p>
                  <p>Если у вас возникают проблемы с подключением, то необходимо: Перейти во вкладку Параметры конфигурации или Настройки, в разделе "DNS" установить Cloudflare (1.1.1.1) или Google DNS (8.8.8.8) для обхода блокировок провайдера.</p>
                  <p>Готово! Hiddify обеспечивает стабильное и быстрое соединение. 🔒</p>
                </div>

                <div className="setup-section">
                  <button
                    className={`section-header ${activeIndex === 1 ? 'active' : ''}`}
                    onClick={() => toggleSection(1)}
                  >
                    <h3>Подключение и настройки</h3>
                    <span className="section-icon">
                      {activeIndex === 1 ? '−' : '+'}
                    </span>
                  </button>
                  
                  <div className={`section-content ${activeIndex === 1 ? 'active' : ''}`}>
                    <div className="section-content-inner">
                      <ol className="steps-list">
                        <li>Откройте приложение Hiddify</li>
                        <li>Нажмите на "+" для добавления профиля</li>
                        <li>Выберите "Добавить из буфера обмена"</li>
                        <li>Вставьте вашу subscription-ссылку</li>
                        <li>Нажмите "Добавить" для сохранения</li>
                        <li>Выберите сервер из списка и подключитесь</li>
                      </ol>
                      <div className="step-screenshot">
                        <img src="/assets/hiddify.jpg" alt="Скриншот: Hiddify Android" />
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}

          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default SetupAndroidPage;